import * as React from 'react';
import { DayPicker } from 'react-day-picker';

import { cn } from '@mint-lib/tw-utils';

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: React.ComponentProps<typeof DayPicker>) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      navLayout="around"
      className={cn(
        'relative shrink-0 gap-2 rounded-sm bg-ui-primary',
        className,
      )}
      modifiersClassNames={{
        eventDays:
          'relative flex flex-col items-end justify-end  before:content-[""] before:bottom-[2px] before:right-[2px] before:absolute before:block before:w-1.5 before:h-1.5 before:rounded-[2px] before:bg-tertiary-dark data-[selected=true]:before:bg-greyscale-white data-[hidden=true]:before:hidden',
      }}
      classNames={{
        months: cn(
          'relative px-2 pb-1',
          props.mode === 'range'
            ? 'flex w-80 justify-center gap-0 md:grid md:w-130.75 md:grid-cols-2 md:gap-4 md:after:absolute md:after:bottom-0 md:after:left-65.5 md:after:h-full md:after:w-px md:after:bg-border-secondary md:after:content-[""]'
            : 'flex w-full gap-0 after:hidden',
        ),
        month: 'w-80 md:w-59',
        month_caption:
          props.mode === 'range'
            ? 'flex w-full pt-2 pb-1'
            : 'flex w-full pt-2 pb-1 justify-center',
        month_grid: ' w-80  md:w-59 h-75 md:h-61 px-2',
        dropdowns: 'flex gap-2',
        months_dropdown: 'w-[122px]',
        years_dropdown: 'w-20',
        weeks: 'grid gap-1 md:gap-0.5 ',
        week: 'grid grid-cols-[repeat(7,40px)] justify-center md:grid-cols-[repeat(7,32px)] gap-1 md:gap-0.5 ',
        weekdays:
          'grid grid-cols-7 justify-center items-center gap-1 md:gap-0.5 px-2',
        weekday:
          'flex items-center justify-center text-text-primary text-[14px] font-normal leading-4 size-10 md:size-8 ',
        caption: 'flex justify-center pt-1 items-center',
        caption_label: 'font-medium flex flex-col text-center',
        button_previous: 'absolute left-1.5 md:left-0 top-2 size-10 md:size-8',
        button_next: 'absolute right-1.5 md:right-0 top-2 size-10 md:size-8',
        day: 'size-10 md:size-8 rounded-sm p-0  hover:border-none',
        day_button:
          'cursor-pointer size-10 md:size-8 rounded-sm bg-transparent-main p-0 font-normal font-normal leading-4 text-[14px] focus:border-none outline-none flex justify-center items-center hover:border-none hover:bg-ui-hover',
        selected:
          'bg-tertiary-main text-greyscale-white rounded-sm [&>button]:hover:bg-tertiary-main data-[outside=true]:bg-transparent-main',
        range_middle:
          'bg-ui-highlight text-tertiary-dark [&>button]:hover:bg-ui-highlight data-[selected=true]:before:bg-tertiary-dark data-[selected=true]:after:bg-tertiary-dark',

        today:
          'relative after:absolute after:right-4 md:after:right-3 after:bottom-[3px] after:h-[4px] after:w-[8px] after:rounded-sm data-[selected=true]:after:bg-greyscale-white after:bg-tertiary-dark after:content-[""] data-[hidden=true]:after:hidden',

        disabled: 'bg-ui-secondary [&>button]:text-action-disabled01',
        outside: 'bg-transparent-main',
      }}
      {...props}
    />
  );
}

export { Calendar };
